import React, { useState } from 'react';
import dayjs from 'dayjs';

import { downloadFile } from 'utility/downloadFile';
import urls from 'engine/urls';

import { Box, Button, Input } from 'components/ui';
import { DateRange } from 'components/containers';

import * as Styled from './ComarchXmlExport.styles';
import { filter } from 'lodash';

export const ComarchXmlExport = ({onErrorResponse}) => {
  const [filters, setFilters] = useState({
    fromDate: dayjs().utc(true).subtract(30, 'day').format('YYYY-MM-DD'),
    toDate: dayjs().utc(true).format('YYYY-MM-DD'),    
  });

  const [accountingId, setAccountingId] = useState(null);
  const [salesPayrollId, setSalesPayrollId] = useState(null);

  const handleExportToComarchXml = () => {
    const params = {
      from: dayjs.utc(filters.fromDate).toISOString(),
      to: dayjs.utc(filters.toDate).endOf('day').toISOString(),
      accountingId: accountingId,
      salesPayrollId: salesPayrollId,
    };

    downloadFile(
      `${urls().GetExportComarchXml}?from=${params.from}&to=${params.to}&accountingId=${params.accountingId}&salesPayrollId=${params.salesPayrollId}`,
      'application/octet-stream',
      'ComarchErpOptima_export.xml',
      onErrorResponse
    );
  };

  return (
    <Styled.Wrapper>
      <Box title="Eksport do Comarch ERP Optima" helperTitle="Comarch ERP Optima" helperMessage='Wygenerowany plik XML może zostać wykorzystany do importu dokumentów do Comarch ERP Optima. W systemie docelowym powinien być włączony tryb pracy rozproszonej wraz z opcją "księgowość".'>
        <Styled.DateRangeWrapper>
          <DateRange
            onChange={(dates) => setFilters({ ...filters, ...dates })}
            toDate={filters.toDate}
            fromDate={filters.fromDate}
          />
        </Styled.DateRangeWrapper>
        <Styled.ParamsWrapper>
          <Input
            onChange={(value) => setAccountingId(value)}
            value={accountingId}
            label="Identyfikator księgowości"
          />
          <Input
            onChange={(value) => setSalesPayrollId(value)}
            value={salesPayrollId}
            label="Identyfikator działu sprzedaży/płac"
          />
        </Styled.ParamsWrapper>
        <Button onClick={handleExportToComarchXml}>Eksportuj</Button>
      </Box>      
    </Styled.Wrapper>
  );
};
